import { EN } from './en'
import { PL } from './pl'

export const TRANSLATE_PL = PL
export const TRANSLATE_EN = EN
